import { InjectionToken } from '@angular/core';
export { IConfigService } from './i-config-service';

export const SERVICE_TOKEN = new InjectionToken('Shared.ConfigService');
